import topbar from "topbar";

declare var window: any;

// Reference: https://hexdocs.pm/phoenix_live_view/js-interop.html#live-navigation-events
const HandlePageLoading = {
  mounted(this: any) {
    window.addEventListener("phx:page-loading-start", () => topbar.show());
    window.addEventListener("phx:page-loading-stop", (e: CustomEvent) => {
      topbar.hide();
      if (e.detail.kind === "patch") window.scrollTo({ top: 0 });
    });
  },
};

export default HandlePageLoading;
